import React, { useState, lazy } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, SendIcon } from 'lucide-react';
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real implementation, you'd send the form data to a server
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
    // Reset submission status after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };
  return <div data-id="element-258">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-259">
        <div className="container mx-auto px-4" data-id="element-260">
          <div className="max-w-3xl mx-auto text-center" data-id="element-261">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-262">Contact Us</h1>
            <p className="text-lg text-gray-200" data-id="element-263">
              Your Trusted Appliance Repair Experts
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-264">
        <div className="container mx-auto px-4" data-id="element-265">
          <div className="max-w-5xl mx-auto" data-id="element-266">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-267">
              {/* Contact Information */}
              <div data-id="element-268">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-8" data-id="element-269">
                  Get In Touch
                </h2>
                <p className="text-gray-700 mb-8" data-id="element-270">
                  Welcome to PinnacleHub, your trusted choice for fast and
                  reliable appliance repairs across the UK. Our expert engineers
                  specialise in servicing essential household appliances.
                  Whether you need an urgent repair, routine maintenance, or a
                  customised service plan, we're here to help.
                </p>
                <div className="space-y-6" data-id="element-271">
                  <div className="flex items-start" data-id="element-272">
                    <div className="bg-[#e6f7f8] p-3 rounded-full mr-4" data-id="element-273">
                      <MapPinIcon size={20} className="text-[#0a3d62]" data-id="element-274" />
                    </div>
                    <div data-id="element-275">
                      <h3 className="font-medium text-[#0a3d62] mb-1" data-id="element-276">
                        Our Address
                      </h3>
                      <p className="text-gray-600" data-id="element-277">
                        56 Main St, Glasgow G71 7LS
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-278">
                    <div className="bg-[#e6f7f8] p-3 rounded-full mr-4" data-id="element-279">
                      <PhoneIcon size={20} className="text-[#0a3d62]" data-id="element-280" />
                    </div>
                    <div data-id="element-281">
                      <h3 className="font-medium text-[#0a3d62] mb-1" data-id="element-282">
                        Phone Number
                      </h3>
                      <p className="text-gray-600" data-id="element-283">0800 055 4969</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-284">
                    <div className="bg-[#e6f7f8] p-3 rounded-full mr-4" data-id="element-285">
                      <MailIcon size={20} className="text-[#0a3d62]" data-id="element-286" />
                    </div>
                    <div data-id="element-287">
                      <h3 className="font-medium text-[#0a3d62] mb-1" data-id="element-288">
                        Email Address
                      </h3>
                      <p className="text-gray-600" data-id="element-289">
                        Bikashbuddha2004@gmail.com
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-290">
                    <div className="bg-[#e6f7f8] p-3 rounded-full mr-4" data-id="element-291">
                      <ClockIcon size={20} className="text-[#0a3d62]" data-id="element-292" />
                    </div>
                    <div data-id="element-293">
                      <h3 className="font-medium text-[#0a3d62] mb-1" data-id="element-294">
                        Opening Hours
                      </h3>
                      <p className="text-gray-600" data-id="element-295">
                        Monday to Friday: 9:00am - 5:00pm
                      </p>
                      <p className="text-gray-600" data-id="element-296">
                        Saturday and Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Contact Form */}
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-297">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-298">
                  Send Us a Message
                </h2>
                {isSubmitted ? <div className="bg-green-50 p-4 rounded-md mb-6" data-id="element-299">
                    <p className="text-green-700" data-id="element-300">
                      Thank you for your message! We'll get back to you shortly.
                    </p>
                  </div> : null}
                <form onSubmit={handleSubmit} data-id="element-301">
                  <div className="mb-4" data-id="element-302">
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-303">
                      Your Name
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3fc1c9]" required data-id="element-304" />
                  </div>
                  <div className="mb-4" data-id="element-305">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-306">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3fc1c9]" required data-id="element-307" />
                  </div>
                  <div className="mb-4" data-id="element-308">
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-309">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3fc1c9]" data-id="element-310" />
                  </div>
                  <div className="mb-6" data-id="element-311">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-312">
                      Your Message
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#3fc1c9]" required data-id="element-313"></textarea>
                  </div>
                  <button type="submit" className="bg-[#0a3d62] hover:bg-[#072f4a] text-white font-medium py-3 px-6 rounded-md transition-colors flex items-center" data-id="element-314">
                    Send Message
                    <SendIcon size={18} className="ml-2" data-id="element-315" />
                  </button>
                </form>
              </div>
            </div>
            {/* Map Background */}
            <div className="mt-16 rounded-lg overflow-hidden shadow-lg h-[400px] relative" data-id="element-316">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2238.8231246701143!2d-4.0661!3d55.8248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTXCsDQ5JzI5LjMiTiA0wrAwMycwNS45Ilc!5e0!3m2!1sen!2suk!4v1620000000000!5m2!1sen!2suk" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="PinnacleHub Location" data-id="element-317"></iframe>
              <div className="absolute top-0 left-0 right-0 bottom-0 bg-[#0a3d62] opacity-10" data-id="element-318"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-xl" data-id="element-319">
                <h3 className="font-bold text-[#0a3d62] mb-2" data-id="element-320">PinnacleHub</h3>
                <p className="text-gray-700" data-id="element-321">56 Main St, Glasgow G71 7LS</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default ContactPage;